import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import globalColors from "../styles/globalColors";

type Props = {
  expanded?: boolean;
  title: string;
};

const ExpandingSection: React.FC<Props> = props => {
  return (
    <Collapse
      bordered={false}
      defaultActiveKey={[props.expanded ? "1" : ""]}
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <FontAwesomeIcon
          icon={faChevronDown}
          transform={{ rotate: isActive ? 180 : 0 }}
          style={styles.icon}
        />
      )}
    >
      <Collapse.Panel
        header={<span css={styles.header}>{props.title}</span>}
        key="1"
        style={styles.panel}
      >
        <div css={styles.content}>{props.children}</div>
      </Collapse.Panel>
    </Collapse>
  );
};

const styles = {
  content: {
    backgroundColor: globalColors.white,
    borderRadius: 5,
    padding: "10px 15px",
    margin: "0 10px 15px"
  },
  header: {
    fontSize: 24,
    fontWeight: 600,
    color: globalColors.textSecondary,
    lineHeight: "50px",
    marginLeft: 15
  },
  icon: {
    fontSize: 20,
    color: globalColors.textSecondary,
    marginRight: 15
  },
  panel: {
    background: globalColors.lightGray,
    borderRadius: 5,
    marginBottom: 24,
    border: 0,
    overflow: "hidden"
  }
};

export default ExpandingSection;
